// Create Lookbook Order Fulfillment
export const CREATE_LOOKBOOK_ORDER_FULFILLMENT_REQUEST = 'CREATE_LOOKBOOK_ORDER_FULFILLMENT_REQUEST';
export const CREATE_LOOKBOOK_ORDER_FULFILLMENT_DONE = 'CREATE_LOOKBOOK_ORDER_FULFILLMENT_DONE';
export const CREATE_LOOKBOOK_ORDER_FULFILLMENT_FAILED = 'CREATE_LOOKBOOK_ORDER_FULFILLMENT_FAILED';
export const CREATE_LOOKBOOK_ORDER_FULFILLMENT_CLEAR_ERRORS = 'CREATE_LOOKBOOK_ORDER_FULFILLMENT_CLEAR_ERRORS';
export const CREATE_LOOKBOOK_ORDER_FULFILLMENT_RESET = 'CREATE_LOOKBOOK_ORDER_FULFILLMENT_RESET';
